/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_TitleInputs */

const en_landing_pricing_title = /** @type {(inputs: Landing_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const zh_landing_pricing_title = /** @type {(inputs: Landing_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Landing_Pricing_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_title = /** @type {((inputs?: Landing_Pricing_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_title(inputs)
	return zh_landing_pricing_title(inputs)
});
export { landing_pricing_title as "landing.pricing.title" }